import React, { Component } from 'react';
import PropTypes from 'prop-types'

import { PootsyTitle, PootsySubtitle, ExternalPrimaryLink } from './DesignFunctions'

import { customerPhoneBG } from '../static/svg/svg-landing'
import flashIcon from '../static/img/flash-icon.png'
import sofaIcon from '../static/img/sofa-icon.png'
import shieldIcon from '../static/img/shield-icon.png'
import giftIcon from '../static/img/gift-icon.png'
import appStoreBadge from '../static/img/app-store-badge.png'
import playStoreBadge from '../static/img/play-store-badge.png'
import arrowWhiteIcon from '../static/img/arrow-right-white.png'
import testimony1Pic from '../static/img/testimony1.jpg'
import testimony2Pic from '../static/img/testimony2.jpg'
import testimony3Pic from '../static/img/testimony3.jpg'
import testimony4Pic from '../static/img/testimony4.jpg'
const localHandheldPhones = [
	require('../static/img/localised-handheld-phones/en.png'),
	require('../static/img/localised-handheld-phones/fr.png'),
	require('../static/img/localised-handheld-phones/nl.png'),
]

export default class LandingCustomerContent extends Component {
	state = {
		testimonials: [{}]
	}
	componentDidMount = () => {
		let testimonials = [
			{ content: 'testimony1', name: 'testimony1_name', location: 'testimony1_location', picture: testimony1Pic },
			{ content: 'testimony2', name: 'testimony2_name', location: 'testimony2_location', picture: testimony2Pic },
			{ content: 'testimony3', name: 'testimony3_name', location: 'testimony3_location', picture: testimony3Pic },
			{ content: 'testimony4', name: 'testimony4_name', location: 'testimony4_location', picture: testimony4Pic },
		]
		this.setState({
			testimonials, testimonyIndex: Math.floor(Math.random() * testimonials.length)
		})
	}
	handleTestimonyBrowse = e => {
		let { testimonials, testimonyIndex } = this.state
		let { direction } = e.target.dataset
		let newIndex = direction === "next" ? testimonyIndex += 1 : testimonyIndex -= 1
		if(newIndex === testimonials.length){
			newIndex = 0
		} else if (newIndex === -1) {
			newIndex = testimonials.length - 1
		}
		this.setState({ testimonyIndex: newIndex })
	}
	render() {
		let { t } = this.context
		let { lang } = this.props
		let { testimonials, testimonyIndex } = this.state
		let handheldPhoneImg = localHandheldPhones.find(key => key.indexOf(lang) !== -1)
		let testimony = testimonials[testimonyIndex || 0]
		return(
			<div className="LandingCustomerContent">
				<section className="why">
					<div className="img-crop">
						{customerPhoneBG}
						<img alt="handheld-phone" className="handheld-phone" src={handheldPhoneImg}/>
					</div>
					<div className="reasons-block">
						<PootsySubtitle subtitle={t('advantages')}/>
						<PootsyTitle title={t('why_use_pootsy')}/>
						<div className="reasons-container">
							<div className="reason">
								<div className="title-block"><img alt="picto" src={flashIcon}/>{t('quick_n_easy')}</div>
								<div className="desc">{t('quick_n_easy_desc')}</div>
							</div>
							<div className="reason">
								<div className="title-block"><img alt="picto" src={giftIcon}/>{t('affordable')}</div>
								<div className="desc">{t('affordable_desc')}</div>
							</div>
							<div className="reason">
								<div className="title-block"><img alt="picto" src={sofaIcon}/>{t('manage_your_devices')}</div>
								<div className="desc">{t('manage_your_devices_desc')}</div>
							</div>
							<div className="reason">
								<div className="title-block"><img alt="picto" src={shieldIcon}/>{t('professionals_only')}</div>
								<div className="desc">{t('professionals_only_desc')}</div>
							</div>
						</div>
					</div>
					<div className="download-prompt">
						<div className="titles">
							<PootsyTitle title={t('download_app')}/>
							<div className="prompt">{t('asap')}</div>
						</div>
						<div className="app-stores">
							<a href="https://itunes.apple.com/be/app/pootsy/id1205673280" target="_blank" rel="noopener noreferrer"><img alt="store-badge"src={appStoreBadge}/></a>
							<a href="https://play.google.com/store/apps/details?id=be.pootsy.customer" target="_blank" rel="noopener noreferrer"><img alt="store-badge"src={playStoreBadge}/></a>
						</div>
					</div>
				</section>
				<section className="how" id="how">
					<div className="titles">
						<div>
							<PootsySubtitle subtitle={t('service_vouchers')}/>
							<PootsyTitle title={t('how_does_it_work')}/>
						</div>
						<ExternalPrimaryLink to={t("service_vouchers_guide_url")} label={t('discover_customer_guide')}/>
					</div>
					<div className="description">{t('how_does_it_work_desc')}</div>
				</section>
				<section className="testimony">
					<img alt="first-adopters" className="people-img" src={testimony.picture}/>
					<div className="description">
						<div className="arrows">
							<img alt="arrow" className="arrow left" src={arrowWhiteIcon} onClick={this.handleTestimonyBrowse} data-direction="prev"/>
							<img alt="arrow" className="arrow right" src={arrowWhiteIcon} onClick={this.handleTestimonyBrowse} data-direction="next"/>
						</div>
						<PootsySubtitle subtitle={t('testimonies')}/>
						<PootsyTitle title={t('they_tested_pootsy')}/>
						{t(testimony.content)}
						<div className="name-place-block"><strong>{t(testimony.name)}</strong> - {t(testimony.location)}</div>
					</div>
				</section>
			{/*
				<section className="whats-up">
					<div className="top">
						<div className="titles">
							<PootsySubtitle subtitle={t('blog')}/>
							<PootsyTitle title={t('whats_up')}/>
						</div>
						<ExternalPrimaryLink to="https://www.linkedin.com/company/pootsy" label={t('more_articles')}/>
					</div>
					<div className="articles">
						{posts.map(post =>
							<a key={post.id} className="article" href={post.url} target="_blank">
								<img alt="thumb" src={post.thumb}/>
								<div className="post-title">{post.title}</div>
								<div className="post-subtext">{post.date}</div>
							</a>
						)}
					</div>
				</section>
			*/}
			</div>
		)
	}
}

LandingCustomerContent.contextTypes = { t: PropTypes.func }


// WEBPACK FOOTER //
// ./src/components/LandingCustomerContent.js